import { UrlConstants } from "../url.constants";
export class ApiUserConstants {
    static URL = UrlConstants.API_V2 + "User";
    static FUNCTION_DELINK_MODULE_ROLE = "DelinkModuleRole";
    static FUNCTION_DELINK_SYSTEM_ROLE = "DelinkSystemRole";
    static FUNCTION_LINK_MODULE_ROLE = "LinkModuleRole";
    static FUNCTION_LINK_SYSTEM_ROLE = "LinkSystemRole";
    static FUNCTION_ACCEPT_DISCLAIMER = "AcceptDisclaimer";
    static RETRIEVE_MY_PORTAL_APPLICATIONS_URL = "RetrieveMyPortalApplications";
    static HAS_OPEN_PORTAL_APPLICATIONS = "HasOpenPortalApplications";
    static SAVE_DEFAULT_APPLICANT_AGENT = "SaveDefaultApplicantAgent";
    static RETRIEVE_DEFAULT_APPLICANT_AGENT = "RetrieveDefaultApplicantAgent";
}
